/**
 * HighlightJS module.
 */

import hljs from 'highlight.js/lib/core';
import hljsRouterOS from 'highlight.js/lib/languages/routeros';
import hljsJavaScript from 'highlight.js/lib/languages/javascript';
import hljsPHP from 'highlight.js/lib/languages/php';
import hljsXML from 'highlight.js/lib/languages/xml';
import hljsPython from 'highlight.js/lib/languages/python';
import hljsJSON from 'highlight.js/lib/languages/json';
import hljsBash from 'highlight.js/lib/languages/bash';
import hljsCurl from 'highlightjs-curl';

hljs.registerLanguage( 'routeros', hljsRouterOS );
hljs.registerLanguage( 'javascript', hljsJavaScript );
hljs.registerLanguage( 'curl', hljsCurl );
hljs.registerLanguage( 'php', hljsPHP );
hljs.registerLanguage( 'xml', hljsXML );
hljs.registerLanguage( 'python', hljsPython );
hljs.registerLanguage( 'json', hljsJSON );
hljs.registerLanguage( 'bash', hljsBash );

hljs.configure( {
	ignoreUnescapedHTML: true,
} );

export default hljs;
